import type { IGetFeedResponse } from '../../feed/getFeed/get-feed-response';
import { getFeedResponseSchema } from '../../feed/getFeed/get-feed-response';
import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';

export async function getBookmarksFeedV1Api(
  cursor?: string,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetFeedResponse>> {
  return getRequest<IGetFeedResponse>({
    path: '/bookmarks/feed/v1',
    schema: getFeedResponseSchema,
    options: {
      ...options,
      params: cursor ? { cursor } : undefined,
    },
  });
}
